import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {toast} from "react-toastify";
import { createEntity } from "../../../actions/entities";
import RefDropdown from "../../widgets/RefDropdown";
import {allProps, endpointCreate, entityCanCreate, entityCanModify, prop, propId} from "../../../utils/metaUtil";
import {allMetaSelector} from "../../../reducers/meta";

class EntityCreatePage extends React.Component {
  state = {
    data: {},
    loading: false,
    errors: {}
  };

  componentWillMount() {
    if (this.props.entity) {
      this.setDefaultState(this.props.entity);
    }
  }
  componentDidMount = () => this.onInit(this.props);
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.entityType !== this.props.match.params.entityType
    ) {
      this.onInit(nextProps);
      this.setDefaultState(nextProps.entity);
    }
  }
  onInit = props => {
  };
  onChange = e =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    });

  onSubmit = event => {
    const entityType = this.props.match.params.entityType;
    event.preventDefault();
    this.props.createEntity(
      this.props.meta,
      entityType,
      this.state.data,
      endpointCreate(this.props.meta, entityType)
    )
        .then(()=>{toast.success(`${entityType} saved`, {position: toast.POSITION.BOTTOM_RIGHT});this.props.history.push(`/entity/${entityType}`)});
  };
  setDefaultState(entity) {
    this.setState({
      data: entity
    });
  }
  renderProperty = (meta, canModify, propKey) => {
    const entityType = this.props.match.params.entityType;
    const property = prop(meta, entityType, propKey);
    const displayName = property.display ? property.display : propKey;
    if (property.visible === false) return;
    if (propKey===propId(meta, entityType)) return;
    if (property.type) {
      return (
        <div key={propKey} className="col-sm-4 col-lg-3 mb-3">
          <label>{displayName}</label>
          <input
            name={propKey}
            className="form-control"
            type="text"
            disabled={property.readonly === true || !canModify}
            onChange={this.onChange}
          />
        </div>
      );
    } else if (property.ref) {
      return (
        <div key={propKey} className="col-sm-4 col-lg-3 mb-3">
          <label>{displayName}</label>
          <RefDropdown
            meta={meta}
            addUnselected
            enabled={canModify}
            name={propKey}
            entityType={property.ref}
            disabled={property.readonly === true || !canModify}
            onChange={this.onChange}
          />
        </div>
      );
    }
  };
  renderEntity = (meta, canModify)  => {
    const entityType = this.props.match.params.entityType;
    return (
      <div className="form-row">
        {Object.keys(allProps(meta, entityType)).map(e => {
          return this.renderProperty(meta, canModify, e);
        })}
      </div>
    );
  };

  render() {
    const entityType = this.props.match.params.entityType;
    const {meta} = this.props;
    const canCreate=entityCanCreate(meta, entityType)
    return (
      <div className="container mt-3">
        <div className="row">
          <div className="col-12">
            <h1>Create - {entityType}</h1>
          </div>
        </div>
          <form onSubmit={this.onSubmit}>
            {this.renderEntity(meta, canCreate)}
            <div className="row">
              <div className="col-sm-6">
                <Link to={`/entity/${entityType}`}>
                  <button type="button" className="btn btn-md btn-primary">
                    CLOSE
                  </button>
                </Link>
              </div>
                {canCreate &&
                <div className="col-sm-6 text-sm-right">
                    <button type="submit" className="btn btn-md btn-primary">
                        CREATE
                    </button>
                </div>
                }
            </div>
          </form>
      </div>
    );
  }
}

EntityCreatePage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      entityType: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
    meta: PropTypes.shape().isRequired
};
EntityCreatePage.defaultProps = {};

function mapStateToProps(state, props) {
  return {
      meta: allMetaSelector(state)
  };
}

export default connect(mapStateToProps, { createEntity })(
  EntityCreatePage
);



// WEBPACK FOOTER //
// ./src/components/pages/entitycreate/EntityCreatePage.js